import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';

import Loading from 'components/loading/Loading';
import { Row, Col, Card, Button } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';

import ExcelExport from 'components/export/ExcelExport';
import { richiediDati, getFile } from './funzioni';

const Documenti = () => {
  const { caricamentoInCorso, documenti } = useSelector((s) => s.documenti99);

  useEffect(() => {
    richiediDati();
  }, []);

  if (caricamentoInCorso) return <Loading />;

  return (
    <>
      <Row>
        <Col>
          <section className="scroll-section">
            <h1>Documents</h1>
            <ExcelExport idTabella="tabella-documenti-99" />
          </section>

          <section className="scroll-section">
            <Card body>
              <BootstrapTable
                striped
                id="tabella-documenti-99"
                bootstrap4
                condensed
                wrapperClasses="table-responsive"
                keyField="Doc"
                data={documenti}
                columns={[
                  {
                    dataField: 'Anno',
                    text: 'Year',
                  },
                  {
                    dataField: 'DataDoc',
                    text: 'Date',
                  },
                  {
                    dataField: 'Totale',
                    text: 'Total',
                    formatter: (cell, row) =>
                      `${row?.Valuta} ${cell
                        ?.toFixed(2)
                        .toString()
                        .split(/(?=(?:\d{3})+(?:\.|$))/g)
                        .join(',')}`,
                  },
                  {
                    dataField: 'Doc',
                    text: 'Document',
                  },
                  {
                    dataField: 'Doc',
                    text: 'Actions',
                    formatter: (cell, row) => (
                      <>
                        <Button onClick={() => getFile(row?.Doc, row?.Anno)}>Download</Button>
                      </>
                    ),
                  },
                ]}
              />
            </Card>
          </section>
        </Col>
      </Row>
    </>
  );
};

export default Documenti;
